function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M480 265H232v179l248 36V265zM216 265H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"
});

function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0nMCAwIDUxMiA1MTInPjx0aXRsZT5pb25pY29ucy12NV9sb2dvczwvdGl0bGU+PHBhdGggZD0nTTQ4MCwyNjVIMjMyVjQ0NGwyNDgsMzZWMjY1WicvPjxwYXRoIGQ9J00yMTYsMjY1SDMyVjQxNWwxODQsMjYuN1YyNjVaJy8+PHBhdGggZD0nTTQ4MCwzMiwyMzIsNjcuNFYyNDlINDgwVjMyWicvPjxwYXRoIGQ9J00yMTYsNjkuNywzMiw5NlYyNDlIMjE2VjY5LjdaJy8+PC9zdmc+";
export { SvgWindows as ReactComponent };